import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import DateUtil from "../../../../util/DateUtil";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";

class GroupsListing extends React.Component {
  render() {
    const { group } = this.props;

    return (
      <tr key={group._id}>
        <td className="align-middle">{group.name.toUpperCase()}</td>
        <td className="align-middle">{group.url}</td>
        <td className="align-middle">
          {group.createdAt !== undefined && DateUtil.toDate(group.createdAt)}
        </td>
        <td className="align-middle text-center tdaction">
          <div className="btn-group" role="group">
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>{<FormattedMessage id="Users" />}</Tooltip>
              )}
              placement="top"
            >
              <Button
                id={"users" + group._id}
                variant="outline-dark"
                onClick={(e) => this.props.openUsersModal(group)}
              >
                <Icon icon="user" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Pharmacies" />}
                </Tooltip>
              )}
              placement="top"
            >
              <Button
                id={"pharmacies" + group._id}
                variant="outline-dark"
                onClick={(e) => this.props.openPharmaciesModal(group)}
              >
                <Icon icon="building" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>{<FormattedMessage id="Edit" />}</Tooltip>
              )}
              placement="top"
            >
              <Button
                id={"edit" + group._id}
                variant="outline-dark"
                onClick={(e) => this.props.openGroupModal(group)}
              >
                <Icon icon="pen-to-square" />
              </Button>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupsListing));
